import common from '@/store/common/mutations';
import * as types from './mutation-types';

import moment from 'moment';
let startDt = moment().startOf('month').format('YYYY-MM-DD');
let endDt = moment().endOf('month').format('YYYY-MM-DD');

import { SEARCH_PARAMS, MK_OBJ_POPUP, PAGING_INFO, POPUP_SEARCH_PARAMS } from './state';
const selectDate1 = (state, { from, to }) => {
	state.searchParams.strtMm01 = from;
	state.searchParams.endMm01 = to;
};
export default {
	...common,
	selectDate1,
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.mkObjList = []; //그리드리스트
		state.ctypeList = []; //조회조건 클레임타입
		state.prcsStepList = []; //조회조건 처리단계
		state.gridPrcStepList = []; //그리드안에 사용여부
		state.popupSearchParams = POPUP_SEARCH_PARAM();
	},
	[types.STATE_APCN_INIT]: state => {
		state.mkObjPopUp = MK_OBJ_POPUP(); //디테일조회시
		state.saveMkObjMst = MK_OBJ_POPUP(); //저장시
		state.mkObjSwapPartsList = []; //이의제기 교환부품정보
		state.mkobTypeList = []; //이의제기 신청시 이의제기 타입
		state.ceqTypeList = []; //정비유형
		state.fileList = []; //파일첨부
		state.occuRegnListPop = []; //이의제기 PWA기초 정보 발생지역
		state.causCdListPop = []; //이의제기 PWA기초 정보 원인코드
		state.ctypeList = []; //이의제기 PWA기초 정보 Ctype
		state.tgrpYnList = []; //이의제기 변제대상
		state.isSaveFlag = false;
		state.prcStateCd = '';
		state.tmpCustSaleDd = ''; //임시 고객판매일자
		state.tmpDgnDd = ''; //임시 진단일자.
		state.readOnlyYn = false; //리드온리구분값
		state.popupSearchParams = POPUP_SEARCH_PARAMS();
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.APCN_INFO]: (state, { key, value }) => {
		state.mkObjPopUp[key] = value;
	},
	[types.CLAM_SAVE_INFO]: (state, { key, value }) => {
		state.saveMkObjMst[key] = value;
	},
	[types.POPUP_SEARCH_PARAM]: (state, payload) => {
		state.popupSearchParams[payload.key] = payload.value;
	}
};
